import styled from "styled-components";
import backgroundGif from "./celebration.gif";

export const Container = styled.div`
  ${(props) =>
    props.isFinish &&
    `background-image: url(${backgroundGif});background-position: center;background-repeat: no-repeat;background-size: cover;`}
  border: 1px solid #c2c6da;
  border-radius: 10.39px;
  height: 99vh;
  width: 99vw;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
